import { ComponentProps } from 'react';
import { dispatchAction } from '@ardoq/rxbeach';
import { openPresentationEditorRequested } from 'streams/presentations/actions';
import styled from 'styled-components';
import { trackPresentationLinkClicked } from './tracking';
import { openSlideMigrationKBArticle } from 'viewDeprecation/util';
import { Link } from '@ardoq/link';
import { Trans } from '@ardoq/i18n';
import type { MigrationId } from './types';

const DescriptionContainer = styled.p`
  margin-bottom: 30px;
`;

export const ViewMigrationGuideLink = (
  props: Omit<ComponentProps<typeof Link>, 'onClick'>
) => (
  <Link {...props} onClick={openSlideMigrationKBArticle} typography="text2" />
);

export const ChecklistDescription = () => (
  <DescriptionContainer>
    <Trans
      i18nKey="migrationChecklist:description.presentations"
      defaults="Below is a list of all presentations in your organization that need to be migrated to the latest version of the selected view. <migrationGuideLink>Find a complete guide on the best way to migrate them here</migrationGuideLink>."
      components={{ migrationGuideLink: <ViewMigrationGuideLink /> }}
    />
  </DescriptionContainer>
);

type ClickableTitleProps = {
  presentationId: string;
  name: string;
  activeMigrationId: MigrationId;
};

export const ClickableTitle = ({
  presentationId,
  name,
  activeMigrationId,
}: ClickableTitleProps) => (
  <Link
    onClick={() => {
      trackPresentationLinkClicked(activeMigrationId);
      dispatchAction(
        openPresentationEditorRequested({
          presentationId,
          shouldNavigateToPresentation: false,
        })
      );
    }}
    underlineOnHover
    hideIcon
    typography="text2"
  >
    {name}
  </Link>
);
